/*
  Pantalla que ve un estudiante cuando su prueba gratis de 3 dias (o su
  plan pago mensual) ya vencio y todavia no ha renovado. En vez de dejarlo
  entrar a Dashboard, App.js lo manda aqui: solo puede elegir un plan
  nuevo o cerrar sesion.
*/
export default function PlanVencido({ onElegirPlan, onCerrarSesion }) {
  return (
    <div style={{ minHeight: '100vh', background: '#F8FAFF', fontFamily: 'system-ui, sans-serif', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 24 }}>
      <div style={{ maxWidth: 440, width: '100%', background: '#fff', border: '1px solid #E2E6F0', borderRadius: 18, padding: 32, textAlign: 'center' }}>
        <div style={{ fontSize: 40, marginBottom: 12 }}>⏰</div>
        <h2 style={{ fontSize: 19, fontWeight: 800, color: '#1A1A2E', marginBottom: 8 }}>
          Tu prueba o tu plan ya vencieron
        </h2>
        <p style={{ color: '#6B7280', fontSize: 14, marginBottom: 22 }}>
          Elige un plan para seguir con tus clases, retos y todo el contenido de EnglishBridge.
        </p>
        <button onClick={onElegirPlan}
          style={{ width: '100%', padding: '12px', background: '#1B3A8C', color: '#fff', border: 'none', borderRadius: 10, fontFamily: 'inherit', fontSize: 14, fontWeight: 700, cursor: 'pointer', marginBottom: 10 }}>
          Ver planes
        </button>
        <button onClick={onCerrarSesion}
          style={{ width: '100%', padding: '11px', background: 'transparent', color: '#6B7280', border: '1.5px solid #E2E6F0', borderRadius: 10, fontFamily: 'inherit', fontSize: 14, fontWeight: 600, cursor: 'pointer' }}>
          Cerrar sesión
        </button>
      </div>
    </div>
  )
}
